import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { clearChunkReloadState, isChunkLoadError, recoverFromChunkLoadError } from '@/shared/lib';
import { EmptyState } from '@/shared/ui';

export function RouteError() {
  const { t } = useTranslation();
  const error = useRouteError();
  const chunkError = isChunkLoadError(error);

  useEffect(() => {
    if (chunkError) recoverFromChunkLoadError();
  }, [chunkError]);

  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : undefined;

  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'grid',
        placeItems: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Box>
        <EmptyState
          page
          tone="bad"
          icon="alert"
          title={t('errors.appErrorTitle')}
          description={chunkError ? t('errors.appErrorUpdated') : t('errors.appErrorGeneral')}
          action={
            <Button
              variant="contained"
              onClick={() => {
                clearChunkReloadState();
                window.location.reload();
              }}
            >
              {t('actions.reload')}
            </Button>
          }
        />
        <Typography
          variant="caption"
          color="text.secondary"
          component="p"
          sx={{ textAlign: 'center' }}
        >
          {t('errors.reloadHint')}
        </Typography>
        {import.meta.env.DEV && detail && (
          <Typography
            variant="caption"
            color="error"
            component="pre"
            sx={{ textAlign: 'center', mt: 2 }}
          >
            {detail}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
